import { render } from "./DashboardEsercizio.vue?vue&type=template&id=07558836"
import script from "./DashboardEsercizio.vue?vue&type=script&lang=js"
export * from "./DashboardEsercizio.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/byte-dev.it/carma.byte-dev.it/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__